import React, { useContext, useEffect, useState } from "react";
import sortBy from "lodash/sortBy";
import AttributeMultiSelectChips from "../components/AttributeMultiSelectChips";
import { useNavigate } from "react-router";
import { AppContext } from "../../../../Context/AppContext";
import AppSettings from "../../../../Settings/AppSettings";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AuthManager from "../../../../Common/AuthManager";
import Utils from "../../../../Common/Utils";
import LongDescription from "../components/LongDescription";
import ProductImages from "../components/ProductImagesNew";
import { toast } from "Components/DesignSystem/Toast/useToast";
import ProductEditSkeleton from "./ProductEditSkeleton";
import ErrorState from "Components/DesignSystem/ErrorState/ErrorState";
import Button from "Components/DesignSystem/Button/Button";
import Typography from "Components/DesignSystem/Typography/Typography";
import Divider from "Components/DesignSystem/Divider/Divider";
import TextField from "Components/DesignSystem/TextField/TextField";
import Textarea from "Components/DesignSystem/Textarea/Textarea";
import Dropdown from "Components/DesignSystem/Dropdown/Dropdown";
import FieldTitle from "Components/DesignSystem/FieldTitle/FieldTitle";
import { Copy, ChevronLeft } from "Components/DesignSystem/Iconography/Icons";
import { NAME_INFO } from "../ProductConstants";
import RulesReRun from "./RulesRerun";
import { useLocation } from "react-router"
import CustomAttributeTag from 'Components/Common/CustomAttributeTag';


const LIFECYCLE_OPTIONS = [
  { value: "Enabled", label: "Enabled" },
  { value: "Disabled", label: "Disabled" },
  { value: "Deleted", label: "Deleted" },
];

function CreateEditProduct({ productid }) {
  const navigate = useNavigate();
  const appData = useContext(AppContext);
  const location = useLocation()

  const industryId =
    appData.get_selected_industry() && appData.get_selected_industry().id;
  const partyId = JSON.parse(localStorage.getItem("current_party_id"));
  const api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const channelKey = appData?.channelKey ?? '';
  const [initialState, setinitialState] = useState({});
  const [initialStateCopy, setinitialStateCopy] = useState(initialState);
  const [selectedAttvalues, setSelectedAttvalues] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [productDescriptionAvailable, setProductDescriptionAvailable] =
    useState(null);
  const [disableButton, setDisableButton] = useState(true);
  const [productImages, setProductImages] = useState([]);
  const [longDescription, setLongDescription] = useState(null);
  const [initialDescriptionAndImages, setInitialDescriptionAndImages] = useState({ description: null, images: [] })


  const [isSaving, setIsSaving] = useState(false);

  const [attributeList, setAttributeList] = useState([]);
  let [selected_Category, setSelected_Category] = React.useState({
    id: null,
    name: "",
  });
  const [formSubmitted, setFormSubmitted] = useState(false);

  const [product_load_indicator, setProduct_load_indicator] = useState({
    loading: false,
    error: false,
    message: null,
  });

  const [rulesRerun, setRulesRerun] = useState(false);

  const loadCategoryList = async () => {
    try {
      setProduct_load_indicator((prev) => {
        return { ...prev, loading: true };
      });
      let res = await ServiceWrapper.doGet(
        `${api_base_url}industry/${industryId}/category`,
        null,
        null,
        AuthManager.getGmsToken()
      );
      if (!res.errorfound) {
        setCategoryList(res.data.data);
        setProduct_load_indicator((prev) => {
          return { ...prev, loading: false };
        });
      } else {
        setProduct_load_indicator((prev) => {
          return { ...prev, loading: false };
        });
      }
    } catch (error) {
      setProduct_load_indicator((prev) => {
        return { ...prev, loading: false };
      });
    }
  };

  useEffect(() => {
    // industryId is undefined until the Searchbar's workspace-bootstrap chain resolves; on a
    // cold deep link this page mounts first, so wait for it and re-fire when it arrives (13936).
    if (Utils.isUndefinedOrNull(industryId)) return;
    loadCategoryList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [industryId]);

  async function load_Product_details_by_id() {
    setProduct_load_indicator({
      loading: true,
      error: false,
      message: "Loading Product Details",
    });

    let res = await ServiceWrapper.doGet(
      `${api_base_url}product/details/${productid} `,
      null,
      null,
      AuthManager.getGmsToken()
    );

    setProductDescriptionAvailable(res?.data?.data?.long_description);

    if (!res.errorfound) {
      if (res?.data?.done === true) {
        var rdata = res.data.data;
        // Set defaults for null values
        if (rdata.image_flag === null || rdata.image_flag === undefined) {
          rdata.image_flag = false;
        }
        if (rdata.product_lifecycle_status === null || rdata.product_lifecycle_status === undefined) {
          rdata.product_lifecycle_status = 'Enabled';
        }
        setProductDescriptionAvailable(rdata.long_description);
        var avalues = [];
        rdata.attr_vals.forEach((attr) => {
          attr.attr_value.forEach((av) => {
            avalues.push({
              label: av.value,
              value: av.val_id,
              id: av.val_id,
              attributeid: attr.attr_id,
            });
          });
        });

        rdata.product_attr_values = {};
        rdata.long_description = Utils.isUndefinedOrNull(rdata.long_description)
          ? false
          : rdata.long_description;
        rdata.product_attr_values.add_attr_values = avalues;
        rdata.product_attr_values.delete_attr_values = [];
        rdata.product_attr_values.add_attr_values = sortBy(
          rdata.product_attr_values.add_attr_values,
          "label"
        );
        rdata.product_attr_values_existing =
          rdata.product_attr_values.add_attr_values;
        setinitialState(rdata);
        setinitialStateCopy(rdata);
        setSelected_Category({ id: rdata.category_id, name: "" });
        setProduct_load_indicator({
          loading: false,
          error: false,
          message: "Product Loaded",
        });
      } else {
        setProduct_load_indicator({
          loading: false,
          error: true,
          message: res.data.message,
        });
      }
    } else {
      setProduct_load_indicator({
        loading: false,
        error: true,
        message: "Error Loading Product Details",
      });
    }
  }

  function get_changes_to_be_saved() {
    var temp = JSON.parse(JSON.stringify(initialState));

    var new_add_set = [];
    temp.product_attr_values.add_attr_values.forEach((aval) => {
      var exists0 = temp.product_attr_values_existing.filter(
        (i) => i.attributeid === aval.attributeid && i.value === aval.value
      );

      var existed_in_original_List = exists0.length > 0;
      if (!existed_in_original_List) {
        new_add_set.push(aval);
      }
    });

    temp.product_attr_values.add_attr_values = new_add_set;
    return temp;
  }

  async function handleSaveEdit() {
    if (isSaving) return;
    setIsSaving(true);

    setFormSubmitted(true);

    if (Utils.isUndefinedOrNull(selected_Category.id)) {
      toast.error("Select a category before saving");
      setIsSaving(false);
      return;
    }

    let url;
    if (productid === "0") {
      url = `product/create`;
    } else {
      url = `product/edit/${productid}`;
    }
    var latest_changes = get_changes_to_be_saved();

    if (
      latest_changes?.min_ad_price === undefined ||
      latest_changes?.min_ad_price === null ||
      latest_changes?.min_ad_price === '' ||
      isNaN(latest_changes.min_ad_price) ||
      parseFloat(latest_changes.min_ad_price) < 0
    ) {
      toast.error("Ad Price must be 0 or greater");
      setIsSaving(false);
      return;
    }

    let productImagesGlobal = appData.productImagesGlobal;

    const finalData = {
      ...latest_changes,
      stage_item_id: 1,
      category_id: selected_Category && selected_Category.id,
      party_id: partyId,
      long_description_data: {
        description: appData.longDescriptionGlobal,
        isRichText: true,
      },
    };
    const final_url = `${api_base_url}${url}`;
    const formData = new FormData();
    if (productImagesGlobal.length > 0 && productImagesGlobal[0] !== null) {
      productImagesGlobal.forEach((file) => {
        formData.append("product_images", file, file.name);
      });

      formData.append(
        "product_images_existing_count",
        productImagesGlobal.length.toString()
      );
    }


    formData.append("data", JSON.stringify(finalData));
    const res = await ServiceWrapper.doPost(
      final_url,
      formData,
      null,
      AuthManager.getGmsToken(),
      true
    );
    setIsSaving(false);

    if (!res.errorfound) {
      if (res.data.done) {
        toast.success(res.data.message + "\n Rules added to Queue");
        if (productid === "0") {
          setTimeout(() => {
            navigate(`/gms/product/details/${res.data.id}`);
          }, 1000);
        } else {
          appData.setProductImagesGlobal([]);
          appData.setLongDescriptionGlobal(null);
          setinitialStateCopy(latest_changes);
          setTimeout(() => {
            navigate(`/gms/product/details/${productid}`);
          }, 1000);
        }
      } else {
        toast.error(res.data.message);
      }
    } else {
      toast.error("Error while saving product, Please try again later");
    }
  }

  const validationOptions = {
    name: {
      required: true,
      minLength: 2,
      maxLength: 60,
      type: "alnum_with_spaces",
    },
    model_number: { required: true },
    version: { required: true },
    min_ad_price: { required: true },
    product_lifecycle_status: { required: true },
  };

  useEffect(() => {
    const formChanged = has_changes();

    setDisableButton(formChanged);

    const imageCount = appData.productCount;
    // Read through a default rather than off the raw value. This effect runs on every change to
    // productImagesGlobal, and an undefined there threw a TypeError that React Router's
    // ErrorBoundary turned into a blank page -- a hard crash from what is only a dirty-state
    // comparison. The context declares File[] and defaults to [], so treating a missing value as
    // "no images" is the right reading, and no single writer can take the page down again.
    if (imageCount !== (appData.productImagesGlobal?.length ?? 0)) {
      setDisableButton(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    initialState,
    initialStateCopy,
    validationOptions,
    appData.productImagesGlobal,
  ]);

  /**
   * True when the form still matches the snapshot it loaded -- i.e. there is nothing to reset.
   * Compares all three halves of that snapshot: the scalar fields, the long description and the
   * images.
   */
  function is_pristine() {
    return (
      JSON.stringify(initialStateCopy) === JSON.stringify(initialState) &&
      JSON.stringify(longDescription) === JSON.stringify(initialDescriptionAndImages?.description) &&
      JSON.stringify(productImages) === JSON.stringify(initialDescriptionAndImages?.images)
    );
  }

  /**
   * Gates SAVE, so it is true when saving should be blocked -- either the form is invalid or
   * nothing has changed. Despite the name it does NOT mean "the form has changes"; it is closer to
   * "there is nothing worth saving". Kept as-is because the Save wiring below depends on it.
   *
   * Reset must NOT use this. It used to, and `!validation[0]` made Reset unavailable whenever the
   * form was invalid -- precisely when a user wants to discard their edits. Clearing the required
   * Name field would have stranded them with no way back short of leaving the page. Reset asks
   * is_pristine() instead. This only became reachable when GMSBorderlessButton started honouring
   * `disabled` (2026-08-03); before that the flag was cosmetic and hid the bug.
   */
  function has_changes() {
    const validation = Utils.validate(initialState, validationOptions);
    return !validation[0] || is_pristine();
  }
  function cancel_changes() {
    // Reset restores the snapshot taken when the form loaded. Both fields are defaulted because
    // `productImages` must never become undefined: ProductImagesNew mirrors it straight into
    // AppContext.productImagesGlobal, which the effect above reads .length off. Feeding undefined
    // through that chain threw a TypeError during render and the ErrorBoundary replaced the whole
    // page -- the reported "clicking Reset errors out" on any product with no images.
    setLongDescription(initialDescriptionAndImages?.description ?? null)
    setProductImages(initialDescriptionAndImages?.images ?? [])
    return setinitialState(initialStateCopy);
  }

  function Initialise_form() {
    var form = {
      name: "",
      model_number: "",
      version: "",
      description: "",
      active: true,
      category_id: "",
      party_id: "",
      source: "1",
      image_flag: false,
      min_ad_price: 0,
      normalized_min_ad_price: 0,
      long_description: false,
      publication: 1,
      sku: "",
      parent_id: "",
      upc: "",
      channel: channelKey,
      stage_item_id: 0,
      product_lifecycle_status: "Enabled",
      product_attr_values: {
        add_attr_values: [],
        delete_attr_values: [],
      },
      product_attr_values_existing: [],
    };
    setinitialState(form);
    setinitialStateCopy(form);
  }

  useEffect(() => {
    if (categoryList && categoryList.length > 0) {
      if (productid === "0" && selected_Category.id === null) {
        const categoryId = new URLSearchParams(location.search).get('categoryid')
        if (!categoryId) return;
        // Only honour a deep-linked category that exists in the loaded Domain's list. Falling
        // back to categoryList[0] silently created the product in an arbitrary category whenever
        // the link's category belonged to another Domain or was stale (13936 follow-up).
        const linkedCategory = categoryList.find(c => c.id === categoryId)
        if (!linkedCategory) {
          toast.warning(
            "The linked category isn't in the current Domain — pick a category or switch Domain."
          );
          return;
        }
        setSelected_Category({
          id: linkedCategory.id,
          name: linkedCategory.name,
        });
      }
    }
  }, [categoryList, location]);

  useEffect(() => {
    Initialise_form();
    if (productid !== "0") {
      load_Product_details_by_id();
    }
  }, [productid]);

  const load_attributes = async (categoryId) => {
    try {
      setProduct_load_indicator((prev) => {
        return { ...prev, loading: true };
      });
      const res = await ServiceWrapper.doPost(
        `${api_base_url}get_attribute_values?page=${1}&limit=${1000}`,
        { category_id: categoryId },
        null,
        AuthManager.getGmsToken()
      );
      setProduct_load_indicator((prev) => {
        return { ...prev, loading: false };
      });
      if (!res.errorfound && res.data.data && res.data.data) {
        setAttributeList(res.data.data ?? []);
      } else {
        setAttributeList([]);
      }
    } catch (error) {
      setProduct_load_indicator((prev) => {
        return { ...prev, loading: false };
      });
      setAttributeList([]);
    }
  };

  useEffect(() => {
    if (Utils.isUndefinedOrNull(selected_Category.id)) return;
    if (Utils.isUndefinedOrNull(industryId)) return;
    if (productid === "0") Initialise_form();
    load_attributes(selected_Category.id);
  }, [selected_Category.id, industryId, channelKey]);

  useEffect(() => {
    if (Utils.isUndefinedOrNull(selectedAttvalues)) return;
    if (Utils.isUndefinedOrNull(selectedAttvalues.val)) return;
    var attributeid = selectedAttvalues.controlid;
    var att = attributeList.filter((i) => i.id === attributeid);
    if (att.length === 0) return;

    var itemp = JSON.parse(JSON.stringify(initialState));

    att[0].values.forEach((aval) => {
      var exists0 = itemp.product_attr_values_existing.filter(
        (i) => i.attributeid === attributeid && i.value === aval.id
      );
      var existed_in_original_List = exists0.length > 0;

      var exists1 = itemp.product_attr_values.add_attr_values.filter(
        (i) => i.attributeid === attributeid && i.value === aval.id
      );
      var existed_in_addList = exists1.length > 0;

      var exists2 = selectedAttvalues.val.filter(
        (i) => i.value === aval.id && i.value !== "*"
      );
      var existed_in_new_list = exists2.length > 0;

      if (existed_in_addList && !existed_in_new_list) {
        itemp.product_attr_values.add_attr_values =
          itemp.product_attr_values.add_attr_values.filter(
            (i) => i.value !== exists1[0].value
          );
        if (productid !== "0" && existed_in_original_List)
          itemp.product_attr_values.delete_attr_values.push(exists1[0]);
      } else if (!existed_in_addList && existed_in_new_list) {
        const nitem = {
          label: aval.value,
          value: aval.id,
          id: aval.id,
          attributeid: attributeid,
        };
        itemp.product_attr_values.add_attr_values.push(nitem);
        if (productid !== "0" && existed_in_original_List)
          itemp.product_attr_values.delete_attr_values.pop(nitem);
      }
    });

    var existsAll = selectedAttvalues.val.filter((i) => i.value === "*");
    var exists_all = existsAll.length > 0;
    var items_for_attributeid =
      itemp.product_attr_values.add_attr_values.filter(
        (i) => i.attributeid === attributeid
      );
    if (!existsAll) {
      existsAll = att[0].values.length === items_for_attributeid.length;
    }

    if (exists_all) {
      const nitem = {
        label: "All Selected",
        value: "*",
        id: "*",
        attributeid: attributeid,
      };
      itemp.product_attr_values.add_attr_values.push(nitem);
    } else {
      itemp.product_attr_values.add_attr_values =
        itemp.product_attr_values.add_attr_values.filter(
          (i) => !(i.value === "*" && i.attributeid === attributeid)
        );
    }

    itemp.product_attr_values.add_attr_values = sortBy(
      itemp.product_attr_values.add_attr_values,
      "label"
    );

    setinitialState(itemp);
  }, [selectedAttvalues]);

  function handleChange(e) {
    let value = e.target.value;
    if (e.target.name === "min_ad_price") {
      const parsed = parseFloat(e.target.value);
      value = isNaN(parsed) ? '' : Math.max(0, parsed);
    }
    setinitialState({ ...initialState, [e.target.name]: value });
  }

  function handleChecked(e) {
    setinitialState({
      ...initialState,
      [e.target.name]: e.target.checked,
    });
  }

  // DS TextField/Textarea hand back (value, event). The event still carries target.name, so the
  // one name-keyed handleChange this form has always used keeps working unchanged (§ 72).
  const handleFieldChange = (value, e) => {
    if (e) handleChange(e);
  };

  const onBackOrCancelClick = () => {
    navigate(-1)
  }

  // The legacy copy control was a bare <i onClick> — mouse-only. A real button keeps the same
  // clipboard logic (modern API, execCommand fallback) and confirms through the DS toast store.
  const copyUid = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(productid).then(() => toast.success("copied"));
    } else {
      const textarea = document.createElement("textarea");
      textarea.value = productid;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try { document.execCommand("copy"); toast.success("copied"); }
      catch { toast.error("Copy failed"); }
      document.body.removeChild(textarea);
    }
  };

  return (
    <div className="tw-text-ink">
      {rulesRerun && (
        <RulesReRun
          rulesRerun={rulesRerun}
          setRulesRerun={setRulesRerun}
          catId={selected_Category.id}
        />
      )}
      {!product_load_indicator.loading &&
        !product_load_indicator.error && (
          <div className="mb-2 mt-2 tw-flex tw-items-start tw-justify-between tw-gap-3">
            <div>
              <button
                type="button"
                data-testid="manageproducts-createeditproduct-div-1"
                className="tw-flex tw-items-center tw-gap-2.5 tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer tw-text-ink"
                onClick={onBackOrCancelClick}
              >
                {/* DS ChevronLeft in currentColor (2026-09-09, user screenshot in dark): the
                    GmsIcons BackArrowIcon bakes stroke="#172B4D" — light ink, invisible on the
                    dark ladder. The ISR page header made the same swap; size 20 matches it. */}
                <ChevronLeft size={20} aria-hidden="true" />
                <Typography className="tw-text-ink" variant="heading-2" as="span">
                  {productid !== "0" ? initialState.name : "Create Product"}
                </Typography>
              </button>
              {productid !== "0" && (
                <div className="tw-flex tw-flex-col tw-ms-5 tw-gap-0.5">
                  <div className="tw-flex tw-items-center tw-gap-1">
                    <Typography variant="sub-title-label" as="span">UID:</Typography>
                    <Typography variant="caption-metadata" as="span" className="tw-text-ink-secondary">{productid}</Typography>
                    <Button
                      variant="subtle"
                      size="sm"
                      data-testid="manageproducts-createeditproduct-i-2"
                      aria-label="Copy UID"
                      onClick={copyUid}
                    >
                      <Copy />
                    </Button>
                  </div>
                  <div className="tw-flex tw-items-center tw-gap-1">
                    <Typography variant="sub-title-label" as="span">Model Number:</Typography>
                    <Typography variant="caption-metadata" as="span" className="tw-text-ink-secondary">{initialState.model_number}</Typography>
                  </div>
                </div>
              )}
            </div>
            <div className="tw-flex tw-items-center tw-gap-3">
              <Button
                variant="subtle"
                data-testid="manageproducts-createeditproduct-reset-btn"
                onClick={() => {
                  cancel_changes();
                }}
                disabled={is_pristine()}
              >
                Reset
              </Button>
              <Button
                variant="secondary"
                data-testid="manageproducts-createeditproduct-button-1"
                onClick={onBackOrCancelClick}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                data-testid="manageproducts-createeditproduct-button-2"
                onClick={() => {
                  if (
                    AuthManager.getPermissions().gmsproducts_update
                  ) {
                    handleSaveEdit();
                  } else {
                    toast.info(
                      "You do not have permission to save the product"
                    );
                  }
                }}
                disabled={isSaving}
              >
                Save
              </Button>
            </div>
          </div>
        )}
      {!product_load_indicator.loading &&
        !product_load_indicator.error && (
          <Divider data-testid="manageproducts-createeditproduct-divider" className="tw-mt-1 tw-mb-2" />
        )}

      {product_load_indicator.loading === true &&
        !product_load_indicator.error && <ProductEditSkeleton />}

      {/* The legacy error branch rendered NOTHING — the message was stored and never shown, so a
          failed load was a blank page (§ 73). */}
      {!product_load_indicator.loading && product_load_indicator.error && (
        <ErrorState
          data-testid="products-edit-error"
          title="We couldn't load this product"
          description={product_load_indicator.message}
          action={
            <Button variant="secondary" data-testid="products-edit-error-back-btn" onClick={onBackOrCancelClick}>
              Go back
            </Button>
          }
        />
      )}

      {!product_load_indicator.loading && !product_load_indicator.error && (
        <>
          {/* Left-aligned with the title (2026-09-09, user request). This was a Bootstrap
              `row d-flex justify-content-center` around a `ps-4 col-9`: the 75%-wide form
              floated to the centre while the header sat at the page's left edge, so
              "Basic Details" started ~270px in from "Stone Rollex…". The width stays 75%
              (`tw-w-9/12`); only the centring and the extra 24px inset are gone, so the first
              column's content edge is the title's edge. The inner `row`/`col-*` grid is
              untouched — its −12px gutters still meet the columns' 12px padding at zero. */}
          <div className="tw-w-full" data-testid="manageproducts-createeditproduct-form">
            <div className="tw-w-9/12 tw-max-w-full">
              <Typography className="tw-text-ink" variant="title-header" as="h2">Basic Details</Typography>

              <div className="mt-2 row">
                <div className="col-4">
                  <Dropdown
                    label="Category"
                    data-testid="manageproducts-createeditproduct-select-3"
                    options={categoryList.map((item) => ({ value: item.id, label: item.name }))}
                    value={selected_Category.id ?? undefined}
                    placeholder="Select category from list"
                    searchable
                    onChange={(value) => {
                      const picked = categoryList.find((item) => item.id === value);
                      setSelected_Category({
                        id: value,
                        name: picked ? picked.name : "",
                      });
                    }}
                    disabled={productid !== "0"}
                  />
                </div>
                {selected_Category.id !== null && (
                  <div className="col-4">
                    <TextField
                      label="UPC"
                      type="number"
                      data-testid="manageproducts-createeditproduct-input-4"
                      id="upc"
                      name="upc"
                      value={initialState.upc}
                      onChange={handleFieldChange}
                      placeholder="upc"
                    />
                  </div>
                )}
              </div>
              {selected_Category.id !== null && (
                <div>
                  <div className="mt-2 row">
                    {productid === "0" && (
                      <>
                        <div className="col-4">
                          <TextField
                            label="SKU"
                            required
                            error={formSubmitted && (!initialState.sku || initialState.sku === '')}
                            id="sku"
                            name="sku"
                            value={initialState.sku}
                            onChange={handleFieldChange}
                            placeholder="sku"
                            data-testid="product-sku-input"
                          />
                        </div>
                        <div className="col-4">
                          <TextField
                            label="Parent ID"
                            required
                            error={formSubmitted && (!initialState.parent_id || initialState.parent_id === '')}
                            id="parent_id"
                            name="parent_id"
                            value={initialState.parent_id}
                            onChange={handleFieldChange}
                            placeholder="Parent ID"
                            data-testid="product-parent-id-input"
                          />
                        </div>
                      </>
                    )}
                    <div className="col-4">
                      <Dropdown
                        label="Product Lifecycle Status"
                        required
                        error={formSubmitted && (!initialState.product_lifecycle_status || initialState.product_lifecycle_status === '')}
                        options={LIFECYCLE_OPTIONS}
                        value={initialState.product_lifecycle_status || ''}
                        onChange={(value) => {
                          setinitialState({ ...initialState, product_lifecycle_status: value });
                        }}
                        data-testid="product-lifecycle-status-select"
                      />
                    </div>
                  </div>
                  <div className="mt-2 row">
                    <div>
                      <TextField
                        label="Name"
                        required
                        error={formSubmitted && (!initialState.name || initialState.name === '')}
                        data-testid="manageproducts-createeditproduct-input-5"
                        id="floatingInput"
                        name="name"
                        value={initialState.name}
                        onChange={handleFieldChange}
                        placeholder="Enter name of the product"
                        helperText={NAME_INFO}
                      />
                    </div>
                  </div>
                  <div className="mt-2 row">
                    <div>
                      <Textarea
                        label="Description"
                        data-testid="manageproducts-createeditproduct-textarea-6"
                        name="description"
                        value={initialState.description}
                        onChange={handleFieldChange}
                        placeholder="Enter description of the product"
                      />
                    </div>
                  </div>
                  <div className="mt-2 row">
                    <div className="col-4">
                      <TextField
                        label="Model Number"
                        required
                        error={formSubmitted && (!initialState.model_number || initialState.model_number === '')}
                        data-testid="manageproducts-createeditproduct-input-7"
                        id="model_number"
                        name="model_number"
                        onChange={handleFieldChange}
                        value={initialState.model_number}
                        placeholder="Model number for product"
                      />
                    </div>
                    <div className="col-4">
                      <TextField
                        label="Version"
                        required
                        error={formSubmitted && (!initialState.version || initialState.version === '')}
                        data-testid="manageproducts-createeditproduct-input-8"
                        id="version"
                        name="version"
                        onChange={handleFieldChange}
                        value={initialState.version}
                        placeholder="version of product"
                      />
                    </div>
                    <div className="col-4">
                      <TextField
                        label="Min AD Price"
                        required
                        type="number"
                        minValue={0}
                        error={formSubmitted && (initialState.min_ad_price === null || initialState.min_ad_price === undefined || initialState.min_ad_price === '')}
                        data-testid="manageproducts-createeditproduct-input-9"
                        id="min_ad_price"
                        name="min_ad_price"
                        value={Utils.round(initialState.min_ad_price) ?? ''}
                        onChange={handleFieldChange}
                        placeholder="min_ad_price"
                      />
                    </div>
                  </div>
                  <div className="mt-2 row">
                    <div className="col-4">
                      <TextField
                        label="Normalized Min AD Price"
                        type="number"
                        data-testid="manageproducts-createeditproduct-input-10"
                        id="normalized_min_ad_price"
                        name="normalized_min_ad_price"
                        value={
                          isNaN(initialState?.normalized_min_ad_price)
                            ? (Utils.round(initialState.normalized_min_ad_price) ?? '')
                            : "-"
                        }
                        onChange={handleFieldChange}
                        placeholder="min_ad_price"
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="mt-3 row">
                    <ProductImages productID={productid}
                      productImages={productImages}
                      setProductImages={setProductImages}
                      setInitialDescriptionAndImages={setInitialDescriptionAndImages}
                    />
                  </div>
                  <div className="mt-3 row">
                    <LongDescription
                      longDescription={longDescription}
                      setLongDescription={setLongDescription}
                      productID={productid}
                      productDescriptionAvailable={productDescriptionAvailable}
                      setInitialDescriptionAndImages={setInitialDescriptionAndImages}
                    />
                  </div>
                  <div className="mt-3 row">
                    <div className="col-12">
                      <div className="flex-wrap gap-1 d-flex justify-content-start">
                        {attributeList &&
                          attributeList.length > 0 &&
                          attributeList.map((singleAttribute, attrIndex) => {
                            var values = singleAttribute.values.map(
                              (val, vindex) => {
                                val = {
                                  label: val.value,
                                  value: val.id,
                                  id: val.id,
                                  attributeid: singleAttribute.id,
                                };
                                return val;
                              }
                            );
                            let selectedvalues = [];
                            selectedvalues =
                              initialState &&
                              initialState.product_attr_values &&
                              initialState.product_attr_values.add_attr_values.filter(
                                (attr) =>
                                  attr.attributeid === singleAttribute.id
                              );

                            return (
                              <div className="" key={singleAttribute.id}>
                                {/* Same field-label chrome as the TextFields above. The legacy
                                    label's classes were missing the tw- prefix — inert in this
                                    build, so it rendered unstyled (§ 72). */}
                                <FieldTitle label={
                                  /* AB#14859 — FieldTitle takes a node, so the glyph sits
                                     inline before the attribute name, as everywhere else. */
                                  singleAttribute.is_custom === true ? (
                                    <span className="tw-inline-flex tw-items-center tw-gap-1">
                                      <CustomAttributeTag data-testid={`product-form-attr-custom-tag-${singleAttribute.id}`} />
                                      {singleAttribute.name}
                                    </span>
                                  ) : singleAttribute.name
                                } className="tw-p-1" />
                                <span>
                                  <AttributeMultiSelectChips
                                    options={values}
                                    selectedOptions={selectedvalues}
                                    controlid={singleAttribute.id}
                                    callback={setSelectedAttvalues}
                                  />
                                </span>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="container-fluid vh-100"></div>
          </div>
        </>
      )}
    </div>
  );
}

export default CreateEditProduct;